import winston from 'winston';
import setup from './index/setup';

// adding a comment to get a fresh commit

// eslint-disable-next-line functional/no-expression-statement
setup();

export default winston;
